// extracted by mini-css-extract-plugin
export var navMenu = "fx_mm";
export var navWrapper = "fx_mn";